export const MOBILE_SHEET_CLOSE_DRAG_DISTANCE = 100

export function shouldCloseMobileSheetDrag(dragOffset: number): boolean {
  return dragOffset > MOBILE_SHEET_CLOSE_DRAG_DISTANCE
}
